import { Button } from '@farmersdog/corgi-x';

import styles from './CTA.css';

export interface FormCTAProps {
  children: string;
  disabled: boolean;
  loading: boolean;
}

export function CTA({ children, disabled, loading }: FormCTAProps) {
  return (
    <Button
      aria-disabled={disabled}
      loading={loading}
      type="submit"
      variant="primary"
      className={styles.cta}
    >
      {children}
    </Button>
  );
}
